import { render, staticRenderFns } from "./MenuValues.vue?vue&type=template&id=1cde8afa&scoped=true&"
import script from "./MenuValues.vue?vue&type=script&lang=js&"
export * from "./MenuValues.vue?vue&type=script&lang=js&"
import style0 from "./MenuValues.vue?vue&type=style&index=0&id=1cde8afa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cde8afa",
  null
  
)

export default component.exports